
















































import Vue from "vue";

import { mapActions } from "vuex";
import * as act from "@/store/modules/DashboardModule/actions";

import * as R from "@/router/routes";
import { Dashboard } from "@/model/data/dashboard/Dashboard";

import EditDashboardCard from "./EditDashboardCard.vue";
import PublicURLCard from "./PublicURLCard.vue";

export default Vue.extend({
    components: {
        EditDashboardCard,
        PublicURLCard,
    },
    data() {
        return {
            R,
            editDashboard: new Dashboard(),
            editDashboardDialog: false,
            showPublicURLCard: false,
        };
    },
    props: {
        dashboard: Dashboard,
    },
    methods: {
        ...mapActions([act.FETCH_DASHBOARD_LIST]),
        onEditDashboardClick() {
            this.editDashboard = this.dashboard.clone();
            this.editDashboardDialog = true;
        },
        onFetchDashboards() {
            this[act.FETCH_DASHBOARD_LIST]();
        },
        onClosePublicURLCard() {
            this.onFetchDashboards();
            this.showPublicURLCard = false;
        },
    },
});
